<template>
  <div :class="mapVisibility ? 'stock_wrapper_nomargin' : 'stock_wrapper'" v-if="canEdit || canDelete" v-cloak>
    <div class="stock_title_holder" v-show="!mapVisibility">
      <search-input :parentClass="'stock_filter_search'" :placeholder="$t('stock_mobile.search_product')" @search="searchByText"></search-input>
    </div>
    <div v-show="!mapVisibility" class="stock_title_holder">
      <div class="stock_title_text">{{ $t('stock_mobile.management') }}</div>
      <b-button class="stock_filter_icon" variant="outline-secondary" size="sm" pill @click="showFilterDialog"
        ><img src="@/assets/images/icons/options.svg"
      /></b-button>

      <b-button class="stock_edit_icon" variant="outline-secondary" size="sm" pill @click="changeSelectionMode"
        ><img src="@/assets/images/icons/edit.svg"
      /></b-button>
      <b-button class="stock_add_icon" variant="outline-secondary" size="sm" pill @click="showTransactions"
        ><img src="@/assets/images/icons/plus.svg"
      /></b-button>
    </div>
    <div class="stock-map-wrapper" v-if="mapVisibility">
      <google-map
        ref="map"
        :showMap="mapVisibility"
        :selection_mode="false"
        :parcel_uuid="selected_parcel_uuid_for_map"
        :initMapInMount="true"
        @onParcelClicked="showParcelInfo"
        @showToastMessage="showToastMessage"
        @onMapReady="onMapReady"
        :parcelInfoDialogVisibility="cellInfoVisibility"
      ></google-map>

      <parcel-info-dialog
        :showPopup="cellInfoVisibility"
        @hidden="hideParcellInfo"
        :filters="workListFilters"
        @closeAndSwitchToList="hideParcellInfoAndShowList"
        :season="currentSeason"
        :parcel_uuid="selected_parcel_uuid_for_map"
        :parcel_name="selected_parcel_name_for_map"
        :parcel_surface="selected_parcel_surface_for_map"
        :layer="selected_layer"
      ></parcel-info-dialog>
    </div>
    <stock-list
      v-show="!mapVisibility"
      ref="stockList"
      :filterData="filterData"
      :hideZeroStock="false"
      @openQuickConsum="openQuickConsumFromStock"
    ></stock-list>
    <stock-filter
      ref="stockFilter"
      :showPopup="stockFilterVisibility"
      @hidden="hideFilterDialog"
      @applyFilters="hideFilterChange"
      :filterData="filterData"
    />
    <mobile-footer :menuItems="footerMenuItems"></mobile-footer>
    <toast-message ref="toastMessage"></toast-message>
    <transactions
      :showPopup="transactionsVisibility"
      :autoOpenConsum="autoOpenConsum"
      :autoConsumOption="autoConsumOption"
      :forceOpenConsum="forceOpenConsum"
      :forceConsumOption="forceConsumOption"
      :preselectedWorksData="preselectedWorksDataForConsum"
      :preselectedProductsForConsum="preselectedProductsForConsum"
      :preselectedMachineForConsum="preselectedMachineForConsum"
      @hidden="hideTransactions"
      @showTransactionMessage="showTransactionMessage"
    ></transactions>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import StockList from "./partials/stockList.vue";
import MobileFooter from "../../components/Mobile/Footer.vue";
import SearchInput from "../../components/Mobile/searchInput.vue";
import ToastMessage from "../../components/Mobile/toastMessage.vue";
import Transactions from "./dialogs/transactions.vue";
import GoogleMap from "@/components/Map/GoogleMap.vue";

import ParcelInfoDialog from "../works/applyArticles/dialogs/parcelInfoDialog.vue";
import StockFilter from "./dialogs/stockFilter.vue";
import { getSubdomain, getDomain } from "../../helpers/common";
import { canDelete, canEdit, permissions, permissionTypes } from "~/helpers/Permissions";
import Forbidden from "~/pages/errors/Forbidden.vue";

export default {
  layout(context) {
    return "noheader";
  },
  name: "StockMobile",
  data() {
    return {
      transactionsVisibility: false,
      stockFilterVisibility: false,
      currentModuleCode: "STOCK",
      selectionMode: false,
      footerMenuItems: [
        {
          code: "STOCK",
          spacer: false,
          image: "products_icon_gray.svg",
          selected_image: "products_icon.svg",
          text: "",
          event: this.showStock,
          selected: true,
        },
        {
          spacer: true,
          event: "",
        },
        {
          code: "MAP",
          spacer: false,
          image: "pin_inactive.svg",
          selected_image: "pin.svg",
          text: "",
          event: this.showMap,
          selected: false,
        },
        {
          spacer: true,
          event: "",
        },
        {
          code: "REPORTS",
          spacer: false,
          image: "report_icon.svg",
          selected_image: "report_icon_green.svg",
          text: "",
          event: this.showReports,
          selected: false,
        },
      ],
      filterData: {
        name: "",
        has_stock: 1,
        has_stock_with_zero: false,
        warehouses: [],
      },
      mapVisibility: false,
      currentSeason: "",
      local_seasons: this.seasons ? this.seasons : [],
      selected_parcel_uuid_for_map: null,
      selected_parcel_name_for_map: null,
      selected_parcel_surface_for_map: null,
      selected_layer: null,
      cellInfoVisibility: false,
      workListFilters: {},
      isMapReady: false,
      autoOpenConsum: false,
      autoOpenConsumHandled: false,
      autoConsumOption: "WORKS",
      forceOpenConsum: false,
      forceConsumOption: "",
      returnToPath: "/works/applyArticles",
      fromApplyArticles: false,
      preselectedWorksDataForConsum: null,
      preselectedProductsForConsum: null,
      preselectedMachineForConsum: null,
    };
  },
  components: {
    Forbidden,
    StockList,
    MobileFooter,
    SearchInput,
    ToastMessage,
    Transactions,
    GoogleMap,
    ParcelInfoDialog,
    StockFilter,
  },
  computed: {
    config() {
      return {
        permission: permissions.STOCK_MANAGEMENT,
        permission_type: permissionTypes.module,
      };
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
    ...mapGetters({
      seasons: "seasons/seasons",
      currentDepartment: "auth/currentDepartment",
      departments: "company/departments",
      company: "auth/domain",
    }),
    current_season_getter() {
      return this.currentSeason;
    },
  },
  watch: {
    seasons: {
      handler: function (newVal) {
        this.local_seasons = newVal;
        //this.setCurrentSeason(newVal);
      },
    },
    currentSeason: {
      handler: function (newVal) {
        this.setLayersSeason(newVal);
      },
    },
    "$i18n.locale": {
      handler: function () {
        this.localizeFooterMenuItems();
      },
    },
  },
  methods: {
    ...mapActions({
      getLayers: "layers/getLayers",
      getSeasons: "seasons/getSeasons",
      changeDepartment: "auth/changeDepartment",
      checkDomain: "auth/checkDomain",
      getDepartments: "company/getDepartments",
    }),
    localizeFooterMenuItems() {
      this.footerMenuItems = this.footerMenuItems.map((item) => {
        if (item.spacer) {
          return item;
        }

        let text = item.text;
        if (item.code === "STOCK") text = this.$t("stock_mobile.footer.stock");
        if (item.code === "MAP") text = this.$t("stock_mobile.footer.map");
        if (item.code === "REPORTS") text = this.$t("stock_mobile.footer.reports");

        return {
          ...item,
          text,
        };
      });
    },
    showFilterDialog() {
      this.stockFilterVisibility = true;
    },
    hideFilterDialog() {
      this.stockFilterVisibility = false;
    },
    hideFilterChange(filters) {
      this.stockFilterVisibility = false;

      if (filters?.has_stock_with_zero) {
        this.$set(this.filterData, "has_stock_with_zero", 1);
        this.$delete(this.filterData, "has_stock");
      } else {
        this.$set(this.filterData, "has_stock", 1);
        this.$delete(this.filterData, "has_stock_with_zero");
      }

      if (filters?.warehouses && filters.warehouses.length > 0) {
        this.$set(this.filterData, "warehouse_uuid", filters.warehouses.join());
      } else {
        this.$delete(this.filterData, "warehouse_uuid");
      }
    },
    async setLayersSeason(season_uuid) {
      if (season_uuid && season_uuid.length > 0 && this.$store.state.layers.layer_season_uuid != season_uuid) {
        this.$store.commit("layers/SET_LAYER_SEASON", season_uuid);

        if (this.isMapReady) {
          this.$refs.map.setLoad(true);
          await this.$store
            .dispatch("layers/getLayers", {
              season_uuid: season_uuid,
            })
            .then((resp) => {
              this.$refs.map.setLoad(false);
            })
            .catch((e) => {
              this.$refs.map.setLoad(false);
              console.error("Layer load error: ", e);
            });
        }
      }
    },
    showstockFilter() {
      this.$refs.toastMessage.showInfo(this.$t("common.feature_in_development"));
    },
    changeSelectionMode() {
      this.$refs.toastMessage.showInfo(this.$t("common.feature_in_development"));
    },
    showStock() {
      this.currentModuleCode = "STOCK";
      this.setActiveFooterMenu("STOCK");
      this.mapVisibility = false;
    },
    showMap() {
      this.currentModuleCode = "MAP";
      this.setActiveFooterMenu("MAP");
      this.mapVisibility = true;
      //this.$refs.toastMessage.showInfo('Funcția este în curs de dezvoltare!');
    },
    showReports() {
      // this.currentModuleCode = 'REPORTS';
      // this.setActiveFooterMenu('REPORTS');
      this.$refs.toastMessage.showInfo(this.$t("common.feature_in_development"));
    },
    searchByText(searchText) {
      this.$set(this.filterData, "name", searchText);
    },
    showTransactions() {
      this.preselectedProductsForConsum = null;
      this.preselectedMachineForConsum = null;
      this.forceOpenConsum = false;
      this.forceConsumOption = "";
      this.transactionsVisibility = true;
    },
    openQuickConsumFromStock(preselectedData) {
      this.preselectedProductsForConsum = preselectedData || null;
      this.preselectedMachineForConsum = null;
      this.forceOpenConsum = true;
      this.forceConsumOption = "";
      this.transactionsVisibility = true;
    },
    hideTransactions() {
      this.transactionsVisibility = false;
      this.preselectedProductsForConsum = null;
      this.preselectedMachineForConsum = null;
      this.forceOpenConsum = false;
      this.forceConsumOption = "";
      if (this.fromApplyArticles) {
        this.$router.push({ path: this.returnToPath || "/works/applyArticles" });
        return;
      }
    },
    showTransactionMessage(message) {
      if (this.fromApplyArticles) {
        if (message) {
          this.$refs.toastMessage.showSuccess(message);
        }
        this.$router.push({ path: this.returnToPath || "/works/applyArticles" });
        return;
      }
      this.$refs.toastMessage.showSuccess(message);
      this.$refs.stockList.reloadList();
    },
    setActiveFooterMenu(code) {
      this.footerMenuItems.forEach((menu_item) => {
        if (menu_item.code == code) {
          menu_item.selected = true;
        } else if (!menu_item.spacer) {
          menu_item.selected = false;
        }
      });
    },
    showToastMessage(type, message) {
      this.$refs.toastMessage.showToastMessage(type, message);
    },
    mapSeasonChanged(event) {
      // console.log('STOCK SEASON CHANGED ', event);
      // let _currentSeason = event.selectedItem ? event.selectedItem.uuid : '';
      // this.currentSeason = _currentSeason;
      // this.$set(this, 'currentSeason', _currentSeason);
      // console.log('START LAYER LOAD FROM STOCK ', this.currentSeason);
      // this.$refs.map.loadLayers(this.currentSeason);
    },
    setCurrentSeason(seasons) {
      if (seasons.length === 0) {
        return;
      }
      let idxSeason = seasons[0];
      for (let i = 0; i < seasons.length; i++) {
        if (new Date(seasons[i].created_at) > new Date(idxSeason.created_at)) {
          idxSeason = seasons[i];
          this.$set(this, "currentSeason", seasons[i].uuid);
        }
      }
      this.$set(this, "currentSeason", idxSeason.uuid);
    },
    showParcelInfo(layer) {
      if (layer && layer.parcel_uuid) {
        this.selected_parcel_uuid_for_map = layer.parcel_uuid;
        this.selected_parcel_name_for_map = layer.name;
        this.selected_parcel_surface_for_map = layer.surface.toString();
        this.selected_layer = layer;
        this.workListFilters.src = "map";
        this.cellInfoVisibility = true;
      }
    },
    hideParcellInfo() {
      this.cellInfoVisibility = false;
    },
    hideParcellInfoAndShowList() {
      this.cellInfoVisibility = false;
      this.mapVisibility = false;
      this.setActiveFooterMenu("STOCK");
    },
    selectFirstDepartment(departments) {
      if (departments.length > 0) {
        this.changeDepartment({
          company_uuid: this.company.uuid,
          company_name: this.company.company,
          department_uuid: departments[0].uuid,
          department_name: departments[0].name,
        }).then((resp) => {
          if (resp.default_department && resp.default_department.department_uuid === departments[0].uuid) {
            this.getSeasons();
          } else {
            this.$refs.toastMessage.showError(this.$t("error_changing_department"));
          }
        });
      } else {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.no_departments_configured"));
      }
    },
    onMapReady(map) {
      this.isMapReady = Boolean(map);
    },
    readPreselectedMachineFromStorage() {
      let machine = null;
      try {
        const raw = window.sessionStorage.getItem("da_preselected_machine_for_stock_consum");
        machine = raw ? JSON.parse(raw) : null;
      } catch (e) {
        machine = null;
      }

      try {
        window.sessionStorage.removeItem("da_preselected_machine_for_stock_consum");
      } catch (e) {
        // ignore storage cleanup errors
      }

      return machine && machine.uuid ? machine : null;
    },
    async initAutoOpenFromRoute() {
      const fromApplyArticles = this.$route?.query?.fromApplyArticles;
      const startConsum = this.$route?.query?.startConsum;
      const returnTo = this.$route?.query?.returnTo;
      const manualWorkPrefill = this.$route?.query?.manualWorkPrefill;
      const seasonUuidFromRoute = this.$route?.query?.seasonUuid || null;
      const consumOption = this.$route?.query?.consumOption || null;
      const preselectMachine = this.$route?.query?.preselectMachine;

      this.fromApplyArticles = fromApplyArticles === "1" || fromApplyArticles === "true";
      this.returnToPath = returnTo || "/works/applyArticles";
      this.autoOpenConsum = this.fromApplyArticles && (startConsum === "1" || startConsum === "true");
      this.autoConsumOption = consumOption || "WORKS";

      if (this.fromApplyArticles && (preselectMachine === "1" || preselectMachine === "true")) {
        this.preselectedMachineForConsum = this.readPreselectedMachineFromStorage();
      } else {
        this.preselectedMachineForConsum = null;
      }

      if (this.fromApplyArticles && (manualWorkPrefill === "1" || manualWorkPrefill === "true")) {
        let rawManualWorkData = null;
        try {
          const raw = window.sessionStorage.getItem("da_manual_work_insert_response_for_stock_consum");
          rawManualWorkData = raw ? JSON.parse(raw) : null;
        } catch (e) {
          rawManualWorkData = null;
        }

        try {
          window.sessionStorage.removeItem("da_manual_work_insert_response_for_stock_consum");
        } catch (e) {
          // ignore storage cleanup errors
        }

        this.preselectedWorksDataForConsum = await this.buildPreselectedWorksDataFromManualInsert(rawManualWorkData, seasonUuidFromRoute);
      } else {
        this.preselectedWorksDataForConsum = null;
      }

      if (this.autoOpenConsum && !this.autoOpenConsumHandled) {
        this.autoOpenConsumHandled = true;
        this.transactionsVisibility = true;
      }
    },
    normalizeManualWorkInsertRows(rawData) {
      if (Array.isArray(rawData)) {
        return rawData;
      }

      if (Array.isArray(rawData?.data)) {
        return rawData.data;
      }

      if (Array.isArray(rawData?.items)) {
        return rawData.items;
      }

      const singleItem = rawData?.data && typeof rawData.data === "object" && !Array.isArray(rawData.data) ? rawData.data : rawData;
      if (singleItem && typeof singleItem === "object") {
        const hasUsefulFields =
          singleItem.uuid ||
          singleItem.spc_uuid ||
          singleItem.season_on_parcel_has_culture_uuid ||
          singleItem.work ||
          singleItem.work_uuid ||
          singleItem.work_date ||
          singleItem.net_surface_worked;
        if (hasUsefulFields) {
          return [singleItem];
        }
      }

      return [];
    },
    extractMachinesFromManualInsertRow(row) {
      const machineMap = {};

      const addMachine = (machineEntry) => {
        if (!machineEntry) {
          return;
        }

        const machinePayload =
          machineEntry?.machine && typeof machineEntry.machine === "object" ? machineEntry.machine : machineEntry;
        const machineUuid = machinePayload?.uuid || machineEntry?.work_machine_uuid || machineEntry?.machine_uuid || null;
        const registrationNumber = machinePayload?.registration_number || machineEntry?.registration_number || "";
        const machineName = registrationNumber || machinePayload?.name || machineEntry?.machine_name || "";

        if (!machineName && !machineUuid) {
          return;
        }

        const key = machineUuid || machineName;
        if (!machineMap[key]) {
          machineMap[key] = machineUuid
            ? {
                uuid: machineUuid,
                name: machineName,
                registration_number: registrationNumber,
              }
            : {
                name: machineName,
                registration_number: registrationNumber,
              };
        }
      };

      if (Array.isArray(row?.machines)) {
        row.machines.forEach((machine) => addMachine(machine));
      }

      if (Array.isArray(row?.work_machines)) {
        row.work_machines.forEach((machine) => addMachine(machine));
      }

      addMachine(row?.work_machine);
      addMachine(row?.machine);

      if (row?.machine_name || row?.machine_registration_number || row?.machine_uuid) {
        addMachine({
          uuid: row.machine_uuid,
          name: row.machine_name,
          registration_number: row.machine_registration_number,
        });
      }

      return Object.values(machineMap);
    },
    extractMachineNameFromManualInsertRow(row) {
      const extractedMachines = this.extractMachinesFromManualInsertRow(row);
      if (extractedMachines.length > 0) {
        return extractedMachines[0].name;
      }

      return (
        row?.machine_name ||
        row?.work_machine?.name ||
        row?.work_machine?.registration_number ||
        row?.machine?.registration_number ||
        row?.machine?.name ||
        ""
      );
    },
    async loadPreselectedParcelsFromWorkContext(rows, fallbackSeasonUuid = null) {
      const contextRow = rows.find((row) => row?.work_uuid || row?.work?.uuid);
      if (!contextRow) {
        return null;
      }

      const workUuid = contextRow?.work_uuid || contextRow?.work?.uuid || null;
      const workName = contextRow?.work_name || contextRow?.work?.name || "";
      const workDate = contextRow?.work_date || contextRow?.date || contextRow?.work?.date || null;

      if (!workUuid || !workDate) {
        return null;
      }

      let parcelsFromApi = [];
      try {
        parcelsFromApi = await this.$store.dispatch("seasonOnParcelHasCulture/nsGetSpcParcels", {
          work_uuid: workUuid,
          date_from: workDate,
          date_to: workDate,
          group_by: "work",
        });
      } catch (e) {
        parcelsFromApi = [];
      }

      if (!Array.isArray(parcelsFromApi) || parcelsFromApi.length === 0) {
        return null;
      }

      const machineMap = {};
      rows.forEach((row) => {
        const machinesForRow = this.extractMachinesFromManualInsertRow(row);
        if (machinesForRow.length > 0) {
          machinesForRow.forEach((machine) => {
            if (machine?.name && !machineMap[machine.name]) {
              machineMap[machine.name] = machine;
            }
          });
          return;
        }

        const machineName = this.extractMachineNameFromManualInsertRow(row);
        if (machineName && !machineMap[machineName]) {
          machineMap[machineName] = { name: machineName };
        }
      });

      const parcels = parcelsFromApi
        .map((parcel) => {
          const parcelUuid = parcel?.uuid || parcel?.parcel_uuid || parcel?.parcel?.uuid || null;
          const seasonUuid = parcel?.season_uuid || parcel?.season?.uuid || fallbackSeasonUuid || null;
          const surfaceWorked = Number.parseFloat(parcel?.surface_worked ?? parcel?.net_surface_worked ?? parcel?.surface ?? 0) || 0;
          const spcItems = Array.isArray(parcel?.spc_items)
            ? [...new Set(parcel.spc_items.filter(Boolean))]
            : [];

          if (spcItems.length === 0) {
            const fallbackSpcUuid = parcel?.season_on_parcel_has_culture_uuid || parcel?.spc_uuid || null;
            if (fallbackSpcUuid) {
              spcItems.push(fallbackSpcUuid);
            }
          }

          let spcItemsInfo = Array.isArray(parcel?.spc_items_info)
            ? parcel.spc_items_info
                .map((spcItem) => ({
                  uuid: spcItem?.uuid,
                  net_surface_worked: Number.parseFloat(spcItem?.net_surface_worked ?? surfaceWorked) || 0,
                }))
                .filter((spcItem) => spcItem.uuid && spcItem.net_surface_worked > 0)
            : [];

          if (spcItemsInfo.length === 0 && spcItems.length > 0 && surfaceWorked > 0) {
            spcItemsInfo = spcItems.map((spcUuid) => ({
              uuid: spcUuid,
              net_surface_worked: surfaceWorked,
            }));
          }

          const machineName = parcel?.machine_name || this.extractMachineNameFromManualInsertRow(contextRow);
          if (machineName && !machineMap[machineName]) {
            machineMap[machineName] = { name: machineName };
          }

          return {
            uuid: parcelUuid,
            season_uuid: seasonUuid,
            name: parcel?.name || parcel?.parcel?.name || "",
            surface_worked: surfaceWorked,
            spc_items: spcItems,
            spc_items_info: spcItemsInfo,
            machine_name: machineName || "",
          };
        })
        .filter((parcel) => parcel.uuid && parcel.season_uuid && parcel.surface_worked > 0 && parcel.spc_items.length > 0);

      if (parcels.length === 0) {
        return null;
      }

      return {
        works: workUuid ? [{ uuid: workUuid, name: workName }] : [],
        parcels,
        machines: Object.values(machineMap),
      };
    },
    async buildPreselectedWorksDataFromManualInsert(rawData, fallbackSeasonUuid = null) {
      const rows = this.normalizeManualWorkInsertRows(rawData);
      if (rows.length === 0) {
        return null;
      }

      const parcelMap = {};
      const workMap = {};
      const machineMap = {};

      rows.forEach((row) => {
        const spcUuid =
          row?.season_on_parcel_has_culture_uuid ||
          row?.season_on_parcel_has_culture?.uuid ||
          row?.spc_uuid ||
          row?.spc?.uuid ||
          row?.uuid ||
          null;
        const parcelUuid =
          row?.parcel_uuid ||
          row?.parcel?.uuid ||
          row?.season_on_parcel?.parcel_uuid ||
          row?.season_on_parcel?.parcel?.uuid ||
          null;
        const seasonUuid =
          row?.season_uuid ||
          row?.season?.uuid ||
          row?.season_on_parcel?.season_uuid ||
          row?.season_on_parcel?.season?.uuid ||
          fallbackSeasonUuid ||
          null;
        const parcelName = row?.parcel_name || row?.parcel?.name || row?.season_on_parcel?.parcel?.name || "";
        const surfaceValue = Number.parseFloat(row?.net_surface_worked ?? row?.surface_worked ?? row?.surface ?? 0) || 0;

        if (!spcUuid || !parcelUuid || !seasonUuid || surfaceValue <= 0) {
          return;
        }

        const key = `${parcelUuid}_${seasonUuid}`;
        if (!parcelMap[key]) {
          parcelMap[key] = {
            uuid: parcelUuid,
            season_uuid: seasonUuid,
            name: parcelName,
            surface_worked: 0,
            spc_items: [],
            spc_items_info: [],
            machine_name: this.extractMachineNameFromManualInsertRow(row),
          };
        }

        if (!parcelMap[key].spc_items.includes(spcUuid)) {
          parcelMap[key].spc_items.push(spcUuid);
        }
        parcelMap[key].spc_items_info.push({ uuid: spcUuid, net_surface_worked: surfaceValue });
        parcelMap[key].surface_worked = Number.parseFloat((parcelMap[key].surface_worked + surfaceValue).toFixed(4));

        const workUuid = row?.work_uuid || row?.work?.uuid || null;
        const workName = row?.work_name || row?.work?.name || "";
        if (workUuid && !workMap[workUuid]) {
          workMap[workUuid] = { uuid: workUuid, name: workName };
        }

        const machinesForRow = this.extractMachinesFromManualInsertRow(row);
        if (machinesForRow.length > 0) {
          machinesForRow.forEach((machine) => {
            if (machine?.name && !machineMap[machine.name]) {
              machineMap[machine.name] = machine;
            }
          });
          return;
        }

        const machineName = this.extractMachineNameFromManualInsertRow(row);
        if (machineName && !machineMap[machineName]) {
          machineMap[machineName] = { name: machineName };
        }
      });

      const parcels = Object.values(parcelMap);
      if (parcels.length === 0) {
        return await this.loadPreselectedParcelsFromWorkContext(rows, fallbackSeasonUuid);
      }

      if (Object.keys(workMap).length === 0) {
        const contextRow = rows.find((row) => row?.work_uuid || row?.work?.uuid);
        const workUuid = contextRow?.work_uuid || contextRow?.work?.uuid || null;
        const workName = contextRow?.work_name || contextRow?.work?.name || "";
        if (workUuid) {
          workMap[workUuid] = { uuid: workUuid, name: workName };
        }
      }

      return {
        works: Object.values(workMap),
        parcels,
        machines: Object.values(machineMap),
      };
    },
  },
  mounted() {
    this.localizeFooterMenuItems();
    this.initAutoOpenFromRoute();
    this.checkDomain({ domain: getSubdomain() })
      .catch((err) => {
        console.log("Check domain error => ", err);
      })
      .then((data) => {
        this.getDepartments({ company_uuid: this.company.uuid }).then((response) => {
          if (!response.find((obj) => obj.uuid === this.currentDepartment?.department_uuid)) {
            this.selectFirstDepartment(response);
          } else {
            this.getSeasons().then((seasonResponse) => {
              // this.setCurrentSeason(seasonResponse.data);
            });
          }
        });
      });
  },
};
</script>

<style lang="scss">
body {
  background-color: #f5f5f5;
}
.toastStyle {
  z-index: 6010;
}
@import "@/assets/scss/stockMobile/stock.scss";
</style>
